export default __webpack_public_path__ + "static/media/enable-video.fe454002.svg";